import * as React from 'react';

export function IconSearch(): JSX.Element {
    return (
        <svg width="1em"
             height="1em"
             viewBox="0 0 26 26"
             shapeRendering="auto">
            <g stroke="none"
               strokeWidth="1"
               fill="none"
               fillRule="evenodd">
                <path fill="currentColor"
                      fillRule="nonzero"
                      d="M25.591,24.273 L18.328,17.009 C19.788,15.253 20.667,12.999 20.667,10.538 C20.667,4.943 16.132,0.409 10.538,0.409 C4.944,0.409 0.409,4.944 0.409,10.538 C0.409,16.132 4.945,20.667 10.538,20.667 C13,20.667 15.254,19.788 17.009,18.328 L24.272,25.592 L25.591,24.273 L25.591,24.273 Z M1.475,10.538 C1.475,5.541 5.54,1.475 10.538,1.475 C15.535,1.475 19.601,5.541 19.601,10.538 C19.601,15.535 15.535,19.601 10.538,19.601 C5.54,19.601 1.475,15.535 1.475,10.538 Z"/>
            </g>
        </svg>
    );
}
